import GridContainer from "@/components/common/GridContainer"
import { getHtmlFromRedactorField } from "@/utils/utils"
import styled from "styled-components"

const SIZE = {
	SMALL: "small",
	LARGE: "large",
}

const StyledTableWrapper = styled.div`
	table {
		width: 100%;
		height: auto;
	}

	table,
	td,
	th {
		border: none !important;
		text-align: left;
		border-bottom: 1px solid ${(props) => props.theme.colors.richBlack} !important;
		padding: 15px 0;
		font-weight: 400 !important;
	}

	em {
		font-style: normal;
		font-weight: 600 !important;
		color: ${(props) => props.theme.colors.pennRed};
	}
`

export default function Table({ data }) {
	const tableContent = data?.tableContent || ""
	const size = data?.size || SIZE.SMALL

	const indent = size === SIZE.SMALL ? 5 : 3
	const colsDesktop = size === SIZE.SMALL ? 6 : 10

	return (
		<GridContainer className={`indent-desktop-${indent} typo-borna`}>
			<StyledTableWrapper
				dangerouslySetInnerHTML={getHtmlFromRedactorField(tableContent)}
				className={`col-desktop-${colsDesktop} col-tablet-8 col-mobile-8`}
			/>
		</GridContainer>
	)
}
